import IconButton from '@mui/material/IconButton';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import * as React from 'react';
import {useState} from 'react';
import {Typography} from '@mui/material';
import ShareDialog from './ShareDialog';
import {faker} from '@faker-js/faker';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import Stack from '@mui/material/Stack';
import BookmarkAddOutlinedIcon from '@mui/icons-material/BookmarkAddOutlined';
import CloseIcon from '@mui/icons-material/Close';
import CoinsModal from '../coins/CoinsModal';
import {getRandomBoolean} from '../../utils/helper';

export default function QAndAFooter({handleSkip, resultImage, screenshotRef, showEditOption, withBoost = false}) {
  const [liked, setLiked] = useState(false)
  const [bookmarked, setBookmarked] = useState(false)
  const [likes, setLikes] = useState(faker.number.int({min: 100, max: 1000}))

  return <Stack direction="row" spacing={2}>
    <IconButton aria-label="add to favorites" onClick={() => {
      if (liked) {
        setLikes(likes - 1)
      } else {
        setLikes(likes + 1)
      }
      setLiked(!liked)
    }}>

      {liked ? <ThumbUpAltRoundedIcon color="primary"/> : <ThumbUpAltOutlinedIcon/>}
      <Typography>
        {likes}
      </Typography>
    </IconButton>

    <ShareDialog resultImage={resultImage} screenshotRef={screenshotRef}/>
    <IconButton aria-label="add to favorites" onClick={() => {
      setBookmarked(!bookmarked)
    }}>
      {bookmarked ? <BookmarkAddedIcon color="primary"/> : <BookmarkAddOutlinedIcon/>}
      <Typography>
        Save
      </Typography>
    </IconButton>

    {getRandomBoolean() ? <CoinsModal/> :
      <>
        {!showEditOption &&
          <IconButton aria-label="Close" onClick={() => handleSkip(true)}>
            <CloseIcon/>
            <Typography>
              Close
            </Typography>
          </IconButton>
        }
      </>
    }
  </Stack>
}

